/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tokens': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M7.158 12.12H4.9V24.6A2.4 2.4 0 007.3 27h3.6a3.6 3.6 0 117.2 0h3.6a2.4 2.4 0 002.4-2.4V12.12h-2.258a1.2 1.2 0 110-2.4H24.1V5.4A2.4 2.4 0 0021.7 3H7.3a2.4 2.4 0 00-2.4 2.4v4.32h2.258a1.2 1.2 0 110 2.4zm9.036-2.4h2.259a1.2 1.2 0 010 2.4h-2.259a1.2 1.2 0 110-2.4zm-5.647 0h2.259a1.2 1.2 0 010 2.4h-2.259a1.2 1.2 0 110-2.4z" _fill="#fff"/>'
  }
})
